import SuperTable from "@decisionmechanics/super-table";
import "@decisionmechanics/super-table/style.css";
import PropTypes from "prop-types";
import { useEffect, useRef } from "react";
import useUndo from "use-undo";

const SuperTableUndo = ({ undoDisabled, ...rest }) => {
  const [packTableState, { set: setPackTable, undo, redo, canUndo, canRedo }] = useUndo(rest.packTable);

  const { present: packTable } = packTableState;

  const initialRender = useRef(false)

  useEffect(() => {
    // Skip change during inital render call as useUndo is already initialised with packTable state
    if (initialRender.current) {
      if (!undoDisabled) {
        rest.onPackTableChanged?.(packTable);
      }
    }
    else
      initialRender.current = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packTable]);

  return (
    <SuperTable
      {...rest}
      packTable={rest.packTable}
      activeContextMenuItems={
        undoDisabled
          ? rest.activeContextMenuItems
          : [
              ...(rest.activeContextMenuItems ?? []).filter((menuItem) => !["undo", "redo"].includes(menuItem)),
              "undo",
              "redo",
            ]
      }
      clipboardTextSeparator="tab"
      externalThousandsSeparator=","
      onPackTableChanged={undoDisabled ? rest.onPackTableChanged : setPackTable}
      canUndo={canUndo}
      canRedo={canRedo}
      onUndo={undo}
      onRedo={redo}
    />
  );
};

SuperTableUndo.propTypes = {
  gridKey: PropTypes.string,
  undoDisabled: PropTypes.bool,
};

SuperTableUndo.defaultProps = {
  gridKey: "grid",
  undoDisabled: true,
};

export default SuperTableUndo;
